import { Check, Loader2, Sparkles } from "lucide-react"

/**
 * Der Agent-Plan als ein Satz mit einem Knopf (Variante A, 14.10.2026).
 *
 * Paul: „ein richtig geiles einfaches Design, damit das jeder bedienen kann" —
 * ohne dass etwas verloren geht. Deshalb ist das hier nur die Vorderseite:
 * „Alle Schritte" klappt die gewohnte Karte mit allen Haken und Feldern auf,
 * und „Ausführen" läuft über genau denselben Weg (Vorschau → Bestätigung).
 */
export function VorschlagKompakt({
  satz, warum, pruefen, antwort, knopfText, anzahlSchritte, busy, kopfExtra,
  onAusfuehren, onAlleSchritte, onAntwort, onNeuPlanen, neuPlanenBusy,
}: {
  satz: string
  warum?: string
  /** Planer war unsicher und hat nichts vorab angehakt. */
  pruefen?: boolean
  antwort?: string
  knopfText: string
  anzahlSchritte: number
  busy?: boolean
  kopfExtra?: React.ReactNode
  onAusfuehren: () => void
  onAlleSchritte: () => void
  onAntwort?: () => void
  onNeuPlanen?: () => void
  neuPlanenBusy?: boolean
}) {
  return (
    <section className="ev2-vorschlag" aria-label="Vorschlag" data-testid="vorschlag-kompakt">
      <div className="ev2-vorschlag-kopf">
        <span className="ev2-vorschlag-marke" aria-hidden><Sparkles className="w-3.5 h-3.5" /></span>
        <span className="ev2-vorschlag-titel">Vorschlag</span>
        {pruefen && <span className="ev2-vorschlag-pruefen">Bitte kurz prüfen</span>}
        {kopfExtra}
        <span style={{ flex: 1 }} />
        <button type="button" className="ev2-vorschlag-link" onClick={onAlleSchritte}>
          Alle Schritte ({anzahlSchritte})
        </button>
      </div>
      <div className="ev2-vorschlag-satz">{satz}</div>
      {warum && <div className="ev2-vorschlag-warum">{warum}</div>}
      {antwort && (
        <button type="button" className="ev2-vorschlag-antwort" onClick={onAntwort}>
          <span>Antworttext · zum Ansehen und Bearbeiten klicken</span>
          „{antwort}“
        </button>
      )}
      <div className="ev2-vorschlag-fuss">
        <button type="button" className="ev2-pk-primary ev2-vorschlag-haupt" onClick={onAusfuehren} disabled={busy}>
          {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Einen Moment…</> : <><Check className="w-4 h-4" /> {knopfText}</>}
        </button>
        <button type="button" className="pp-btn" onClick={onAlleSchritte}>Anpassen</button>
        <span style={{ flex: 1 }} />
        {onNeuPlanen && (
          <button type="button" className="ev2-vorschlag-link" onClick={onNeuPlanen} disabled={neuPlanenBusy}
            title="Fragt den Agenten erneut — mit dem heutigen Stand aus HERO">
            {neuPlanenBusy ? "Plant neu…" : "Neu planen"}
          </button>
        )}
      </div>
    </section>
  )
}
